import api from '../../services/api';
import BaseService from '../BaseService';

class VisitasService extends BaseService {
    constructor() {
        super('/visitas/');
    }

    exportCSV(params) {
        return api.get(this.resource, { params: { ...params, formato: 'csv' }, responseType: 'blob' });
    }
}

export default new VisitasService();
